module.exports = __webpack_public_path__ + "static/media/phoneIcon.f7aeabdd.svg";